// extracted by mini-css-extract-plugin
module.exports = {"button":"Incorrect_button__iswsE","full-width-avatar":"Incorrect_full-width-avatar__2nubY","container":"Incorrect_container__hBN5L","image":"Incorrect_image__3g36o"};